var en_ZA = {};
module['exports'] = en_ZA;
en_ZA.title = "English (South Africa)";
en_ZA.address = require("./address");
en_ZA.internet = require("./internet");
en_ZA.name = require("./name");
en_ZA.phone_number = require("./phone_number");
en_ZA.cell_phone = require("./cell_phone");
en_ZA.company = require("./company");
